<template>
  <div>
    <div class="flex a-center j-center" style="height: 60px;background-color: #F7F9FD">
      <span class="bold fs-16">页面修改</span>
    </div>
    <div class="bg-white p-v-20" style="min-height: 200px">
      <div class="text-left m-h-20  flex a-center formItemBox">
        <div class="fs-14 color-333 bold flex-s-0 m-r-20">
          页面标题：
        </div>
        <div class="m-t-10 flex a-center">
          <Input class="w-300" maxlength="18" placeholder="输入标题" show-word-limit v-model="editData.pageName"/>
        </div>
      </div>
      <div class="text-left m-h-20 flex a-center formItemBox">
        <div class="fs-14 color-333 bold flex-s-0 m-r-20">
          标题显示：
        </div>
        <radio :false-value="0" :true-value="1" class="m-l-10" size="small" v-model="editData.showTitle">
          <span class="fs-14">隐藏</span>
        </radio>
        <radio :false-value="1" :true-value="0" class="m-l-10" size="small" v-model="editData.showTitle">
          <span class="fs-14">显示</span>
        </radio>
      </div>
      <div class="p-r-20 m-t-10 flex a-center formItemBox " style="padding-left: 12px">
        <span class="fs-14 color-333 bold " style="margin-right: 14px">标题颜色：</span>
        <div class="border m-l-5 colorDiv">
          {{ editData.textColor }}
        </div>
        <ColorPicker class="m-l-10 ld-color-pick" recommend v-model="editData.textColor"/>
      </div>
      <div class="p-r-20 m-t-10 flex a-center formItemBox " style="padding-left: 12px">
        <span class="fs-14 color-333 bold " style="margin-right: 14px">标题背景：</span>
        <div class="border m-l-5 colorDiv">
          {{ editData.titleBgColor }}
        </div>
        <ColorPicker class="m-l-10 ld-color-pick" recommend v-model="editData.titleBgColor"/>
      </div>
      <div class="p-r-20  formItemBox" style="padding-left: 12px;">
        <div class="fs-14 color-333 m-t-10 bold m-r-10">标题Logo：</div>
        <div class="m-t-10 border" style="width: 100px; height: 100px;border-radius:4px;">
          <img-upload @uploadSuccess="uploadImageSuccess" class="h-full w-full" picurl="platform/icon/module/">
            <div class="h-full w-full flex j-center a-center" slot="tip">
              <div class="w-full h-full flex j-center a-center relative " v-if="editData.logo">
                <img :src="editData.logo" alt="" key="customIcon"
                     style="max-width: 100%;max-height: 100%"/>
                <img @click.stop="onLogoClear" class="w-15 h-15 absolute top--8 right--6"
                     src="../../../../assets/common/ic_remove.png"/>
              </div>
              <i class="icon-add_small fs-30" style="color: #999999" v-if="!editData.logo"></i>
            </div>
          </img-upload>
        </div>
      </div>
    </div>
    <div class="flex a-center j-center" style="height: 60px;background-color: #F7F9FD">
      <Button @click="onCancelClick" class="m-r-10">取消</Button>
      <Button @click="onConfigClick" class="m-l-10">确定</Button>
    </div>
  </div>
</template>

<script>
import ImgUpload from '../../../../components/common/ImgUpload'
import {mapActions} from 'vuex'

export default {
  name: 'StylePageSettingWidget',
  components: {ImgUpload},
  props: {
    editData: {
      type: Object,
      default: () => {
        return {
          editPageId: 0,
          pageName: '',
          customColor: '#F8F8F9',
          showTitle: 0,
          textColor: '#333333',
          jumpLink: '',
          titleBgColor: 'white',
          hasRenovation: 1,
          loadOtherUrl: '',
          logo: '',
          logoWidth: 0,
          logoHeight: 0,
          bgPic: '',
          bgPicWidth: 0,
          bgPicHeight: 0,
          shareCover: '',
          shareTitle: '',
          buttonUrl: '',
          extension: null,
        }
      }
    }
  },
  data () {
    return {}
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {

    },
    uploadImageSuccess (data) {
      if (data && data.length) {
        this.editData.logo = data[0].url
        this.editData.logoWidth = data[0].width
        this.editData.logoHeight = data[0].height
      }
    },
    onLogoClear () {
      this.editData.logo = ''
      this.editData.logoWidth = 0
      this.editData.logoHeight = 0
    },
    onCancelClick () {
      this.$emit('cancel')
    },
    onConfigClick () {
      let pageConfig = this.editData
      let pageName = pageConfig.pageName || ''
      let pageStyle = {
        pageBgColor: pageConfig.customColor,
        navTitleColor: pageConfig.textColor,
        navBgColor: pageConfig.titleBgColor,
        logoWidth: pageConfig.logoWidth,
        logoHeight: pageConfig.logoHeight,
        pageBgImgWidth: pageConfig.bgPicWidth,
        pageBgImgHeight: pageConfig.bgPicHeight
      }
      let pageExtension = {
        ...this.editData.extension,
        showNav: pageConfig.showTitle,
        logo: pageConfig.logo || '',
        pageBgImg: pageConfig.bgPic || '',
        buttonUrl: pageConfig.buttonUrl || '',
      }
      let params = {
        title: pageName,
        style: JSON.stringify(pageStyle) || '',
        extension: JSON.stringify(pageExtension) || '',
      }
      this.editPageBase({
        id: this.editData.editPageId,
        params
      }).then(res => {
        if (res.code === 0) {
          this.$emit('config')
        }
        if (res.msg) {
          this.$Message.info(res.msg)
        }
      })
    },
    ...mapActions([
      'getPageDetail',
      'editPageBase'
    ])
  }
}
</script>

<style scoped>
.ld-color-pick >>> .ivu-icon-ios-arrow-down {
  display: none;
}

.ld-color-pick >>> .ivu-input-icon-normal + .ivu-input {
  padding-right: 7px;
}

.formItemBox {
  margin: 0 !important;
  min-height: 46px;
  padding-left: 30px !important;
}

.colorDiv {
  border: 1px solid #dcdee2;
  border-radius: 4px;
  color: #515a6e;
  padding: 4px 7px;
  width: 100px;
  height: 32px;
  line-height: 24px;
  font-size: 12px;
}
</style>
